import { createSlice } from '@reduxjs/toolkit';
import { getAuditById, getAudits } from './thunk';

export const initialState = {
  isLoading: false,
  audits: [],
  audit: {},
  meta: {},
  error: {},
  filters: [],
  isError: false,
};

const auditSlice = createSlice({
  name: 'Audits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAudits.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAudits.fulfilled, (state, action) => {
      state.isLoading = false;
      state.audits = action.payload?.data;
      state.meta = action.payload?.meta;
    });
    builder.addCase(getAudits.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload?.error || null;
      console.log(action);
    });

    builder.addCase(getAuditById.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAuditById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.audit = action.payload;
      state.meta = action.payload?.meta;
    });
    builder.addCase(getAuditById.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload?.error || null;
      console.log(action);
    });
  },
});

export default auditSlice.reducer;
